<template>
  <div>
    <v-row justify="center">
      <v-dialog fullscreen hide-overlay transition="dialog-bottom-transition" v-model="dialog.shows.showOperation">
        <v-card>
          <v-toolbar color="primary" dark elevation="12">
            <v-btn @click="dialog.shows.showOperation = false" dark icon>
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-toolbar-title>{{ $vuetify.lang.t('$vuetify.users.operation.title', [getTitle()]) }}</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <operation :card="card" :user="user" ref="operationRef"></operation>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-row>
  </div>
</template>

<script>
  import Operation from '../operation/Index';

  export default {
    name: "OperationForm",
    props: {
      dialog: {
        type: Object,
        default: function () {
          return {
            title: "$vuetify.users.new.title",
            shows: {
              showOperation: false
            },
            saveBtnTitle: "$vuetify.btn.save",
            action: "create"
          };
        }
      }
    },
    data: () => ({
      user: {
        id: null,
        username: null,
        profile: {
          fullName: null
        }
      },
      card: {
        title: false,
        maxHeight: "max-height: 495px"
      }
    }),
    methods: {
      setUser(item) {
        this.user.id = item.id;
        this.user.username = item.username;
        this.user.profile.fullName = item.profile.fullName;
      },
      getTitle() {
        if (this.user["username"]) return this.user["username"];
        return " - ";
      }
    },
    components: {
      Operation
    }
  }
</script>

<style scoped>

</style>